import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Outlet, useNavigate } from "react-router-dom";

import { useUser } from "../../../hooks/useUser";

export function AuthGuard() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: user, isLoading, authInitialized, session } = useUser();

  useEffect(() => {
    if (!authInitialized || isLoading) return;

    if (!user || !user.isMentee) {
      queryClient.removeQueries({ queryKey: ["supabaseUser"] });
    }

    if (!user) {
      navigate("/auth/login");
      return;
    }

    if (!user.isMentee) {
      navigate("/auth/login", { state: { authError: "not-mentee" } });
      return;
    }
  }, [authInitialized, isLoading, user, navigate, queryClient]);

  if (!authInitialized || isLoading || !session) {
    return null;
  }

  if (!user || !user.isMentee) {
    return null;
  }

  return <Outlet />;
}
